"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TextField = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TextField, _Component);

  var _super = _createSuper(TextField);

  function TextField(props) {
    var _this$props$defaultVa;

    var _this;

    (0, _classCallCheck2.default)(this, TextField);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "input", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      inputValue: (_this$props$defaultVa = _this.props.defaultValue) !== null && _this$props$defaultVa !== void 0 ? _this$props$defaultVa : ''
    });
    _this.handleOnChange = _this.handleOnChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOnKeyUp = _this.handleOnKeyUp.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TextField, [{
    key: "handleOnChange",
    value: function handleOnChange(value) {
      this.setState({
        inputValue: value
      });

      if (this.props.onChange && typeof this.props.onChange === 'function') {
        this.props.onChange(value);
      }
    }
  }, {
    key: "handleOnKeyUp",
    value: function handleOnKeyUp(value) {
      this.setState({
        inputValue: value
      });

      if (this.props.onKeyUp && typeof this.props.onKeyUp === 'function') {
        this.props.onKeyUp(value);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      var _this2 = this;

      if (previousProps.enableFocusToInput !== this.props.enableFocusToInput && this.props.enableFocusToInput && this.input) {
        this.input.focus();
        setTimeout(function () {
          if (_this2.input) {
            _this2.input.focus();
          }
        }, 100);
      }

      if (previousProps.updateInputValue !== this.props.updateInputValue && typeof this.props.updateInputValue === 'string' && this.input) {
        this.input.value = this.props.updateInputValue;
        this.setState({
          inputValue: this.props.updateInputValue
        });
        this.handleOnChange(this.props.updateInputValue);
        this.handleOnKeyUp(this.props.updateInputValue);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var inputValue = this.state.inputValue;
      var _this$props = this.props,
          name = _this$props.name,
          ariaLabel = _this$props.ariaLabel,
          id = _this$props.id,
          label = _this$props.label,
          subtext = _this$props.subtext,
          _this$props$placehold = _this$props.placeholder,
          placeholder = _this$props$placehold === void 0 ? '' : _this$props$placehold,
          className = _this$props.className,
          onBlur = _this$props.onBlur,
          size = _this$props.size,
          isInline = _this$props.isInline,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          direction = _this$props.direction,
          isControl = _this$props.isControl,
          _this$props$type = _this$props.type,
          type = _this$props$type === void 0 ? 'text' : _this$props$type,
          _this$props$contextTe = _this$props.contextText,
          contextText = _this$props$contextTe === void 0 ? '' : _this$props$contextTe,
          tooltipComponent = _this$props.tooltipComponent,
          min = _this$props.min,
          max = _this$props.max,
          required = _this$props.required;
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('a-text-field', "a-text-field--size-".concat(size !== null && size !== void 0 ? size : 'fullWidth'), "a-text-field--direction-".concat(direction !== null && direction !== void 0 ? direction : 'vertical'), {
          'a-text-field--type-inline': isInline,
          'a-text-field--app-control': isControl,
          'a-text-field--app-destination': !isControl
        })
      }, Boolean(label) && (0, _preact.h)("label", {
        className: "a-text-field--label",
        htmlFor: id
      }, label, tooltipComponent), Boolean(subtext) && (0, _preact.h)("p", {
        className: "a-text-field--subtext"
      }, subtext), (0, _preact.h)("div", {
        className: "a-text-field--input-container"
      }, Boolean(contextText) && (0, _preact.h)("div", {
        className: "a-text-field--context-text"
      }, contextText), (0, _preact.h)("input", {
        ref: function ref(input) {
          _this3.input = input;
        },
        placeholder: placeholder,
        className: "a-text-field--input ".concat(className),
        id: id,
        type: type,
        name: name,
        min: min,
        max: max,
        "aria-label": ariaLabel,
        value: inputValue,
        onChange: function onChange(event) {
          return _this3.handleOnChange(event.target.value);
        },
        onKeyUp: function onKeyUp(event) {
          return _this3.handleOnKeyUp(event.target.value);
        },
        onBlur: onBlur,
        disabled: disabled,
        required: required
      })));
    }
  }]);
  return TextField;
}(_preact.Component);

var _default = TextField;
exports.default = _default;